module.exports = __webpack_public_path__ + "static/media/arrow.8ab240bf.svg";